import React from 'react'

import { pxToRem } from '@/shared/styles/themes'
import { Box, Paper, Slide, Stack, styled, Typography } from '@mui/material'

import { Button } from '../components/Button/Button'

import { useConsent } from './CookieConsentContext'

export const CookieConsentBanner: React.FC = () => {
  const { consent, hasConsented, acceptAll, rejectNonEssential, openPreferences } = useConsent()

  // Don't show banner if user has already made a choice
  const show = consent === null && !hasConsented

  return (
    <Slide direction="up" in={show} mountOnEnter unmountOnExit>
      <StyledBanner elevation={8}>
        <Box sx={{ flex: 1 }}>
          <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 600 }}>
            We use cookies
          </Typography>
          <Typography variant="body2" color="text.secondary">
            We use cookies to improve your experience and for analytics.
            Read our{' '}
            <a href="/privacy-policy" style={{ color: 'inherit', textDecoration: 'underline' }}>
              Privacy Policy
            </a>{' '}
            for details.
          </Typography>
        </Box>
        <StyledActions direction={{ xs: 'column', sm: 'row' }} spacing={1}>
          <StyledTextButton onClick={openPreferences}>
            Manage Preferences
          </StyledTextButton>
          <Button outline onClick={rejectNonEssential} size="small">
            Reject Non-Essential
          </Button>
          <Button primary onClick={acceptAll} size="small">
            Accept All
          </Button>
        </StyledActions>
      </StyledBanner>
    </Slide>
  )
}

const StyledBanner = styled(Paper)(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: theme.zIndex.snackbar + 1,
  display: 'flex',
  alignItems: 'center',
  gap: pxToRem(16),
  padding: `${pxToRem(16)} ${pxToRem(24)}`,
  borderRadius: 0,
  flexDirection: 'column',

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    padding: `${pxToRem(16)} ${pxToRem(32)}`,
  },
}))

const StyledActions = styled(Stack)({
  flexShrink: 0,
})

const StyledTextButton = styled('button')(({ theme }) => ({
  background: 'none',
  border: 'none',
  color: theme.palette.text.secondary,
  cursor: 'pointer',
  fontSize: pxToRem(13),
  textDecoration: 'underline',
  padding: `${pxToRem(4)} ${pxToRem(8)}`,
  whiteSpace: 'nowrap',

  '&:hover': {
    color: theme.palette.text.primary,
  },
}))
